import { z } from 'zod';

export const agentRunIdSchema = z.uuid();

export function isValidAgentRunId(value: unknown): value is string {
    return agentRunIdSchema.safeParse(value).success;
}
